import { useAsyncValue, type LoaderFunctionArgs, redirect } from "react-router";

import AssignmentApi from "@/api/assignment-api";
import AssignmentList from "@/components/assignment-list";
import ApiErrorComponent from "@/components/common/api-error";
import DeferredLoading from "@/components/common/deferred-loading";
import { usePageTitle } from "@/hooks/title";
import type ApiError from "@/models/ApiError";
import type { Assignment } from "@/types/assignment";

export async function loader({ request }: LoaderFunctionArgs) {
  const { data: assignments, error: assignments_error } = await AssignmentApi.fetchAll(
    request.signal,
  );
  const only_assignment = assignments?.length === 1 ? assignments[0] : undefined;
  if (only_assignment) {
    return redirect(`/assignment/${only_assignment.id}`);
  }
  return {
    response: {
      data: assignments,
      error: assignments_error,
    },
  } as const;
}

const Start = () => {
  usePageTitle("Start");
  return (
    <DeferredLoading>
      <StartComponent />
    </DeferredLoading>
  );
};

function StartComponent() {
  const { data: assignments, error } = useAsyncValue() as {
    data: Assignment[] | null;
    error: ApiError | null;
  };

  if (error) {
    return <ApiErrorComponent error={error} />;
  }
  return (
    <div className="mt-12">
      <AssignmentList assignments={assignments ?? []} />
    </div>
  );
}

export default Start;
